import { SidUserClient } from "@sid/sid_client";
import { BaseInfo, CommonAttrInfo, LinkageUserData, ManageInfo, MemberAgreementInfo, ShippingInfo, SiteInfo, UserBase } from "@/commons/interfaces";
import { InjectionKey, reactive } from "vue";
import { LinkageUserItem } from "@/modules/linkage/linkageUserItem";
import JumpLaboProfile from "@/components/Linkage/Sites/JumpLaboProfile.vue";
import JumpLaboConfirm from "@/components/Linkage/Sites/JumpLaboConfirm.vue";

// ジャンプラボ関連定数定義
/** 連携ID */
export const JUMP_LABO_LINKAGE_ID = 12;
/** 連携名称 */
export const JUMP_LABO_LINKAGE_NAME = "JumpLabo";
/** 連携パス */
export const JUMP_LABO_PATH = "jump_labo";
/** サイト固有情報APIパス */
export const JUMP_LABO_SITE_UNIQ_API_PATH = "/jump_labo/me";
/** デフォルトコールバックURL */
export const JUMP_LABO_DEFAULT_CALLBACK_URL = process.env.VUE_APP_JUMP_LABO_DEFAULT_CALLBACK_URL;
/** 許容コールバックURL */
export const JUMP_LABO_ACCEPT_CALLBACK_URLS = process.env.VUE_APP_JUMP_LABO_ACCEPT_CALLBACK_URLS.split(",").map((url: string) => `^${url}(\\?.*)?$`);
/** サービス規約URL */
export const JUMP_LABO_SERVICE_TERM_URL = process.env.VUE_APP_JUMP_LABO_SERVICE_TERM_URL;
/** メールアドレスドメイン */
export const JUMP_LABO_EMAIL_DOMAINS = [
    "jump-lab.jp",
];
/** 基本属性情報入力 */
export const JUMP_LABO_PROFILE_COMPONENT = JumpLaboProfile;
/** 基本属性情報確認 */
export const JUMP_LABO_CONFIRM_COMPONENT = JumpLaboConfirm;

/**
 * ジャンプラボ連携画面用基本属性情報管理クラス
 */
export class JumpLaboUserBase implements LinkageUserData<UserBase> {

    /** インジェクションキー */
    public static injectionKey: InjectionKey<LinkageUserItem<LinkageUserData<UserBase>>> = Symbol("JumpLaboUserBase");

    /** 基本属性情報 */
    public readonly data: UserBase = reactive(new UserBase());
    /**
     * @inheritDoc LinkageUserData
     */
    public initData(): void {
        this.copy(new UserBase());
    }

    /**
     * @inheritDoc LinkageUserData
     */
    public getData(): UserBase {
        return this.data;
    }

    /**
     * @inheritDoc LinkageUserData
     */
    public copy(obj: UserBase): void {
        this.data.identityId = obj.identityId;
        this.data.userName = obj.userName;
        this.data.baseInfo = Object.assign(new BaseInfo(), obj.baseInfo);
        this.data.shippingInfo = obj.shippingInfo?.map(inf => Object.assign(new ShippingInfo(), inf)) || [];
        this.data.siteInfo = obj.siteInfo?.map(inf => Object.assign(new SiteInfo(), inf)) || [];
        this.data.commonAttrInfo = Object.assign(new CommonAttrInfo(), obj.commonAttrInfo);
        this.data.memberAgreeInfo = Object.assign(new MemberAgreementInfo(), obj.memberAgreeInfo);
        this.data.manageInfo = Object.assign(new ManageInfo(), obj.manageInfo);
    }

    /**
     * @inheritDoc LinkageUserData
     */
    public async fetch(sidClient: SidUserClient): Promise<void> {
        const response = await sidClient.getUserAttr()
            .then(res => res.data)
            .catch(res => {
                if (res.response?.status === 404) {
                    return new UserBase();   
                } else {
                    throw new Error("Failed to get information.");
                }
            });
        this.copy(response);
    }

    /**
     * @inheritDoc LinkageUserData
     */
    public checkRequired(): boolean {
        // 基本属性情報の有無
        if (!this.data.identityId) return false;
        // 登録者情報
        // if (!this.data.baseInfo.firstName) return false;
        // if (!this.data.baseInfo.lastName) return false;
        // if (!this.data.baseInfo.firstKana) return false;
        // if (!this.data.baseInfo.lastKana) return false;
        // if (!this.data.baseInfo.zipCode) return false;
        // if (!this.data.baseInfo.prefecture) return false;
        // if (!this.data.baseInfo.address) return false;
        // if (!this.data.baseInfo.building) return false;
        if (!this.data.baseInfo.email) return false;
        // if (!this.data.baseInfo.tel) return false;
        // 属性情報
        // if (!this.data.commonAttrInfo.gender) return false;
        // if (!this.data.commonAttrInfo.birthday) return false;
        // if (!this.data.commonAttrInfo.imagePath) return false;
        // if (!this.data.commonAttrInfo.nickName) return false;
        // if (this.data.commonAttrInfo.isMarried === null || this.data.commonAttrInfo.isMarried === undefined) return false;
        // if (this.data.commonAttrInfo.hasChild === null || this.data.commonAttrInfo.hasChild === undefined) return false;
        // if (!this.data.commonAttrInfo.bloodType) return false;
        return true;
    }

    /**
     * @inheritDoc LinkageUserData
     */
    getInjectKey(): InjectionKey<LinkageUserItem<LinkageUserData<UserBase>>> {
        return JumpLaboUserBase.injectionKey;
    }

}